// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1z-2";
export var blackBorderOnHover = "_1z-7";
export var cell = "_1z-6";
export var cellContainer = "_1z-3";
export var checked = "_1z-8";
export var disabled = "_1z-5";
export var featuredIconCellContainer = "_1z-9";
export var featuredIconTextContainer = "_1z-b";
export var featuredIconWrapper = "_1z-a";
export var noBorder = "_1z-c";
export var orangeSelectedRow = "_4l-3";
export var overflowableText = "_1z-0";
export var overflowableTextContainer = "_1z-1";
export var row = "_1y-0";
export var rowCheckboxCell = "_1z-4";
export var selectableTable = "_4l-2";